import React from 'react';
import * as jnb from 'react-bootstrap';
import { ApprovalReportData } from './ApprovalReportData';
export default function ApprovalPrintPdf(props) {
    const { showList } = props;
    var content = `                     The Cheques/DD's are recieved from the following organisations in respect of payment of 1 % Cess to APB & OCWWB. I therefore request you to credit <b>Rs.17,21,224 /- Reupees( Seveenteen Lakhs Twenty One Thousand Two Hundred And Twenty Two Rupees Only )...  </b>in <b>SB A/C. No.39537243616</b> , IFSC Code <b>SBIN0000948</b> petaining to APB&OCWWB Board immediately.The Details of Cheques/DDs are as follows`
    var todata = String.raw`
   To,
   The Manager,
   State Bank Of India,
   BRP Road Branch,
   Vijayawada - 520 001,`
    var fromdata = String.raw`
   From,
   The Secretory & CEO,
   AP B&OCWW Board,
   Vijayawada`
    return (
        <div>

            <jnb.Row className='mt-3 px-2' style={{ textAlign: "center", justifyContent: "center" }}>
                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                    <h5 style={{ fontSize: "17px", fontFamily: "bold" }}>
                        <b>AP BUILDING AND OTHER CONTRUCTION WORKER'S WELFARE BOARD :: VIJAYAWADA</b> </h5>
                </jnb.Col>
            </jnb.Row>
            <jnb.Row className='px-4'>
                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex justify-content-between">
                    <div style={{ whiteSpace: "pre-wrap" }}>
                        {fromdata}
                    </div>
                    <div style={{ whiteSpace: "pre-wrap" }}>
                        {todata}
                    </div>
                </jnb.Col>
            </jnb.Row>
            <jnb.Row className='' style={{ textAlign: "center", justifyContent: "center" }}>
                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>

                    <h5 style={{ fontSize: "15px", textDecoration: 'underline' }}>Lr.No.B/265/2022 Dated:29.12.2023</h5>
                </jnb.Col>

            </jnb.Row>
            <jnb.Row className='px-4' >
                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                <jnb.Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9} className='px-4'>
                    <p>Sir,</p>

                    <jnb.Row className='px-4'>
                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            Sub : &emsp;Cess Collection - Cheques/DD'S -payment of cess - Remittance in <b>SB A/C. No.39537243616</b> , IFSC Code <b>SBIN0000948</b> Requested-Reg.
                        </jnb.Col>
                        <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            Ref : &emsp;Cheques/DD'S(11) enclosed for a amount of <b>Rs.17,21,224 /- Reupees( Seveenteen Lakhs Twenty One Thousand Two Hundred And Twenty Two Rupees Only </b>).
                        </jnb.Col>
                    </jnb.Row>
                </jnb.Col>
                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className='px-4' style={{ textAlign: "center", justifyContent: "center" }}>
                    --------
                </jnb.Col>
            </jnb.Row>
            <jnb.Row className='px-4'>
                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                <jnb.Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10} style={{ whiteSpace: "pre-wrap" }} >
                    {content}
                </jnb.Col>
                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
            </jnb.Row>
            <jnb.Row className='px-3 pt-3'>

                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} >
                    <ApprovalReportData showList={showList} />
                </jnb.Col>

            </jnb.Row>
            <jnb.Row className='px-4'>
                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                <jnb.Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10}>
                    In the connection, I request you kindly furnish the credit particulars of the above cheques / DD's sent herely on daily basis to this office for record. </jnb.Col>
                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1}></jnb.Col>
                <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className='text-center'>
                    Thanking You,
                </jnb.Col>
            </jnb.Row>
            <jnb.Row className='px-4'>

                <jnb.Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10} className='text-right'>
                    <p>Yours sincerely,</p>
                    <p>Finance Manager</p>
                </jnb.Col>
                <jnb.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mt-3'></jnb.Col>

            </jnb.Row>

        </div>
    )
}
